import React from 'react';
import { RiInformationLine } from '@remixicon/react';
import ArrowTooltip, { TooltipPosition } from '../../atoms/ArrowTooltip';

export type InfoTooltipProps = {
  id?: string;
  content?: string | React.ReactNode;
  tooltipPosition?: TooltipPosition;
  classes?: string;
};

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  id,
  content,
  tooltipPosition = TooltipPosition.TOP_RIGHT,
  classes = '',
}) => {
  return (
    <ArrowTooltip
      id={id}
      content={content}
      position={tooltipPosition}
      className={classes}
    >
      <RiInformationLine
        size={16}
        color='#52525B'
        tabIndex={0}
        aria-describedby={`${id}-info`}
        style={{
          marginBottom: '-2px',
        }}
      />
    </ArrowTooltip>
  );
};

export default InfoTooltip;
